export default __webpack_public_path__ + "static/media/Ham_Menu.7115acd6.svg";